import React, { useMemo } from "react";
import { Grid, Button } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import moment from "moment";

import { getPlan, getPlanPrice } from "../../common/plans";

function PlansSummaryComponent({
  plan,
  bootcampUser,
  pay,
  freeTrial,
  back,
  subData,
  addOn,
}) {
  const isFreePlan = plan?.includes("free");
  const isAnnual = plan?.includes("annually");
  const isMonthly = plan?.includes("monthly");

  const displayPlanName = bootcampUser ? "Bootcamp" : getPlan(plan);

  const amount = useMemo(() => {
    if (isFreePlan) return null;
    if (bootcampUser) return 400;

    const basePrice = getPlanPrice(plan);
    if (!addOn) return basePrice;

    const addOnPrice = isMonthly ? 40 : 400;
    return basePrice + addOnPrice;
  }, [addOn, bootcampUser, isFreePlan, isMonthly, plan]);

  const billedText = useMemo(() => {
    if (isFreePlan) return null;
    if (bootcampUser) return "One-Time";
    return isAnnual ? "Annually" : "Monthly";
  }, [bootcampUser, isAnnual, isFreePlan]);

  const paymentDate = useMemo(() => {
    const today = moment();
    const in14Days = moment().add(14, "days");

    const shouldChargeToday =
      bootcampUser ||
      isFreePlan ||
      subData?.freeTrialUsed === true ||
      !freeTrial;

    return (shouldChargeToday ? today : in14Days).format("MM/DD/YYYY");
  }, [bootcampUser, freeTrial, isFreePlan, subData]);

  return (
    <Grid container>
      <Grid item xs={12} md={2} />

      <Grid item xs={12} md={8}>
        <Grid container>
          <Grid item xs={12} className="plans-step-back">
            {back && (
              <Button onClick={back}>
                <ArrowBack />
              </Button>
            )}
          </Grid>

          <Grid item xs={12} className="plans-summary-caption">
            Summary
          </Grid>

          <Grid item xs={12} className="plans-summary-row">
            <span>Plan</span>
            {displayPlanName}
          </Grid>

          {!isFreePlan && (
            <Grid item xs={12} className="plans-summary-row">
              <span>Amount</span>${amount}
            </Grid>
          )}

          {!isFreePlan && (
            <Grid item xs={12} className="plans-summary-row">
              <span>Billed</span>
              {billedText}
            </Grid>
          )}

          <Grid item xs={12} className="plans-summary-row">
            <span>Payment Date</span>
            {paymentDate}
          </Grid>

          <Grid item xs={12}>
            <Button className="plan-button" onClick={pay}>
              Continue
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={2} />
    </Grid>
  );
}

export default PlansSummaryComponent;
